const InvalidEnityMap = [{
  entity: '&#8232;',
  replacement: '<br />'
}, {
  entity: '\u2028',
  replacement: '<br />'
}];
export const processEntities = html => {
  let sanitizedHtml = html;
  InvalidEnityMap.forEach(({
    entity,
    replacement
  }) => {
    sanitizedHtml = sanitizedHtml.replace(entity, replacement);
  });
  return sanitizedHtml;
};